<template>
	<div>
		
			<div class="subBanner" style="background:url(/images/detailBg.png) center bottom no-repeat">
					<div class="w1200">
							<div class="itemBanner">{{keyword}}</div>
					</div>
			</div>
			<div class="w1200">  
				<el-skeleton :rows="20" :loading="loadingMask" animated>
				<div class="itemWap">
					<div class="report_nav">
						<div class="report_nav_h" :class="colid?'':'on'">
							<img src="/images/leftBarIcon.png"/>
							<router-link :to="{ name: 'theme', params: { pagetype: '1' }, query: { col : sourcecol }}">内容纵览</router-link>
						</div>
						<dl v-if="item.artcount" v-for="(item,index) in indexDataList">
							<template v-if="item.ChildList">
								<dt><router-link :to="{ name: 'theme', params: { pagetype: '2', colid: item.colID }, query: { col : sourcecol }}" :class="item.colID==colid?'on':''" >{{item.colName}}</router-link></dt>
								<dd v-for="(citem,cindex) in item.ChildList">
									<router-link v-if="citem.colID&&citem.artLst.length" :to="{ name: 'theme', params: { pagetype: '3', colid: citem.colID }, query: { col : sourcecol }}" :class="citem.colID==colid?'on':''" >{{citem.colName}}</router-link>
									<router-link v-else-if="citem.tagId&&citem.artLst.length" :to="{ name: 'theme', params: { pagetype: '4', colid: citem.tagId }, query: { col : sourcecol }}" :class="citem.tagId==colid?'on':''" >{{citem.tagName}}</router-link>
								</dd>
							</template>
							<template v-else>
								<dt>
									<router-link v-if="item.colID&&item.Type!='4'" :to="{ name: 'theme', params: { pagetype: '3', colid: item.colID }, query: { col : sourcecol }}" :class="item.colID==colid?'on':''">{{item.colName}}</router-link>
									<router-link v-else-if="item.colID" :to="{ name: 'theme', params: { pagetype: '4', colid: item.colID }, query: { col : sourcecol }}" :class="item.colID==colid?'on':''">{{item.colName}}</router-link>
								</dt>
							</template>
						</dl>
					</div>
					
					<themelist v-if="pagetype==3||pagetype==4" v-bind:colname="colname" v-bind:sourcecol="sourcecol"></themelist>
					
					<themeindex v-else v-bind:resultlist="selDataList" v-bind:sourcecol="sourcecol" v-bind:keyword="keyword"></themeindex>
					
				</div>
				</el-skeleton>
			</div>
		
	</div>
</template>

<script>
	import themeindex from '@/components/theme-index.vue'
	import themelist from '@/components/theme-list.vue'
	export default {
		data() {
			return {
				loadingMask: false,
				keyword: '',
				pagetype:'',
				keytype:'',
				colid:'',
				colname:'',
				sourcecol:'',
				indexDataList: [],
				selDataList:[],
				pageNum: 1,
				pageSize: 10,
				moreTotalCount: '',
				moreDataList:[]
			}
		},
		components:{
			themeindex,
			themelist
		},
		watch: {
			$route(to, from) {
				if (to.params.colid != from.params.colid) {
					this.keyword = this.$route.params.searchword;
					this.pagetype=this.$route.params.pagetype;
					this.colid=this.$route.params.colid;
					this.sourcecol=this.$route.query.col?this.$route.query.col:'';
					this.selcol();
					document.body.scrollTop = 0;
					document.documentElement.scrollTop = 0;
				}
			}
		},
		mounted: function() {
			this.keyword = this.$route.params.searchword;
			this.pagetype=this.$route.params.pagetype;
			this.colid=this.$route.params.colid;
			this.sourcecol=this.$route.query.col?this.$route.query.col:'';
			document.title=this.keyword+'-数字中国专版';
			this.$track([
				['pagetype','场景检索'],
				['reqtype','2'],
				['searchkeyword',this.keyword],
				['column',this.colid]
			]);
			this.getallfnc();
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		methods: {
			selcol:function(){
				if(this.pagetype=='2'&&this.colid){
					for(var i=0;i<this.indexDataList.length;i++){
						if(this.indexDataList[i].colID==this.colid){
							this.selDataList=[this.indexDataList[i]];
							break;
						}
					}
				}
				else if(this.pagetype=='3'&&this.colid){
					for(var i=0;i<this.indexDataList.length;i++){
						if(this.indexDataList[i].colID==this.colid){
							this.colname=this.indexDataList[i].colName;
							break;
						}
						if(this.indexDataList[i].ChildList){
							for(var j=0;j<this.indexDataList[i].ChildList.length;j++){
								if(this.indexDataList[i].ChildList[j].colID==this.colid){
									this.colname=this.indexDataList[i].ChildList[j].colName;
									break;
								}
							}
						}
					}
				}
				else if(this.pagetype=='4'&&this.colid){
					for(var i=0;i<this.indexDataList.length;i++){
						if(this.indexDataList[i].colID==this.colid){
							this.colname=this.indexDataList[i].colName;
							break;
						}
						if(this.indexDataList[i].ChildList){
							for(var j=0;j<this.indexDataList[i].ChildList.length;j++){
								if(this.indexDataList[i].ChildList[j].tagId==this.colid){
									this.colname=this.indexDataList[i].ChildList[j].tagName;
									break;
								}
							}
						}
					}
				}
				else{
					this.selDataList=this.indexDataList;
				}
			},
			getallfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'SearchInfo/DEconThemeListInfo',
						responseType: 'json',
						params: {
							strKey: this.keyword,
							ColAlias: this.sourcecol,
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						_this.indexDataList = response.data.data.data.column;
						for(var i=0;i<_this.indexDataList.length;i++){
							var tempcount=0;
							if(_this.indexDataList[i].ChildList){
								for(var j=0;j<_this.indexDataList[i].ChildList.length;j++){
									tempcount+=_this.indexDataList[i].ChildList[j].artLst.length;
								}
							}
							else{
								tempcount+=_this.indexDataList[i].artLst.length;
							}
							_this.indexDataList[i].artcount=tempcount;
						}
						_this.loadingMask = false;
						_this.selcol();
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});;
			},
		}
	}
</script>

<style>
</style>
